import { defineComponent as p, openBlock as t, createElementBlock as a, mergeProps as v, unref as o, renderSlot as i, createElementVNode as e, createCommentVNode as u } from "vue";
import { useScalarIcon as L } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, m = { key: 1 }, f = { key: 2 }, h = { key: 3 }, k = { key: 4 }, w = { key: 5 }, A = {
  name: "ScalarIconArrowsMerge"
}, Z = /* @__PURE__ */ p({
  ...A,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = L(s);
    return (V, l) => (t(), a("svg", v({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      i(V.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", g, l[0] || (l[0] = [
        e("path", { d: "M196,40v64a12,12,0,0,1-3.51,8.49L140,165V203l11.51-11.52a12,12,0,0,1,17,17l-32,32a12,12,0,0,1-17,0l-32-32a12,12,0,0,1,17-17L116,203V165L63.51,112.49A12,12,0,0,1,60,104V40a12,12,0,0,1,24,0V99l44,44,44-44V40a12,12,0,0,1,24,0Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", m, l[1] || (l[1] = [
        e("path", {
          d: "M184,40v64l-56,56L72,104V40Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M192,40v64a8,8,0,0,1-2.34,5.66L136,163.31v49.38l18.34-18.35a8,8,0,0,1,11.32,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,212.69V163.31L66.34,109.66A8,8,0,0,1,64,104V40a8,8,0,0,1,16,0v60.69l48,48,48-48V40a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", f, l[2] || (l[2] = [
        e("path", { d: "M192,40v64a8,8,0,0,1-2.34,5.66L136,163.31V192h24a8,8,0,0,1,5.66,13.66l-32,32a8,8,0,0,1-11.32,0l-32-32A8,8,0,0,1,96,192h24V163.31L66.34,109.66A8,8,0,0,1,64,104V40a8,8,0,0,1,16,0v60.69l48,48,48-48V40a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", h, l[3] || (l[3] = [
        e("path", { d: "M190,40v64a6,6,0,0,1-1.76,4.24L134,162.49v55l21.76-21.75a6,6,0,0,1,8.48,8.48l-32,32a6,6,0,0,1-8.48,0l-32-32a6,6,0,0,1,8.48-8.48L122,217.51v-55L67.76,108.24A6,6,0,0,1,66,104V40a6,6,0,0,1,12,0v61.51l50,50,50-50V40a6,6,0,0,1,12,0Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", k, l[4] || (l[4] = [
        e("path", { d: "M192,40v64a8,8,0,0,1-2.34,5.66L136,163.31v49.38l18.34-18.35a8,8,0,0,1,11.32,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,212.69V163.31L66.34,109.66A8,8,0,0,1,64,104V40a8,8,0,0,1,16,0v60.69l48,48,48-48V40a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", w, l[5] || (l[5] = [
        e("path", { d: "M188,40v64a4,4,0,0,1-1.17,2.83L132,161.66v60.68l25.17-25.17a4,4,0,0,1,5.66,5.66l-32,32a4,4,0,0,1-5.66,0l-32-32a4,4,0,0,1,5.66-5.66L124,222.34V161.66L69.17,106.83A4,4,0,0,1,68,104V40a4,4,0,0,1,8,0v62.34l52,52,52-52V40a4,4,0,0,1,8,0Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  Z as default
};
